import { Navigate } from 'react-router';
import { sanitizeSearchString } from '../utils/string';

const urlParams = new URLSearchParams(window.location.search);
const action = urlParams.get('action')?.toLowerCase() || '';

const m = new Map([
  ['uilogin', '/preLogin'],
  ['uilogout', '/preLogin'],
  ['newaccount', '/register'],
  ['register', '/register'],
  ['resetpassword', '/resetPassword'],
  ['changpwd', '/resetPassword'],
  ['forgetpassword', '/resetPassword'],
]);

const redirectPath = m.get(action) || '/404';

export const GatewayRedirect: React.FC = () => {
  return <Navigate to={{ pathname: redirectPath, search: sanitizeSearchString(window.location.search) }} replace />;
};
